<template>
    <div>
        <game-detail :details='details'></game-detail>
    </div>
</template>

<script>
import gameDetail from '../../components/gamedetail/gamedetail'

import logo_img from '../../images/xianlaigame/xl_anhui.png'
import ercodeimg from '../../images/gamecenter_ercode/ercode_anhui.png'
import list_img1 from '../../images/download/down-anhui1.jpg'
import list_img2 from '../../images/download/down-anhui2.jpg'
import list_img3 from '../../images/download/down-anhui3.jpg'
export default {
    data(){
        return{
            details:{
                logo_img:logo_img,
                name:'闲来安徽麻将',
                size:'89.01',
                load_count:'196',
                desp:'安徽麻将是款画面精美、操作简单的麻将。现主要包括“合肥”“安庆”“淮南”等特色玩法。还有风靡全国的红中赖子和推到胡玩法。',
                ios_url:'http://app6.auwvnd.cn/?downloadfrom=anhui',
                android_url:'http://app6.auwvnd.cn/?downloadfrom=anhui',
                ercodeimg:ercodeimg,
                list_img1:list_img1,
                list_img2:list_img2,
                list_img3:list_img3,
                cut_img1:''
            }
        }
    },
    components:{
        gameDetail
    }
}
</script>

<style scoped>

</style>
